import React, { useState, useEffect } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import axios from "axios";
import { ListGroup } from 'react-bootstrap';

 
 
 
const Trova_classi_assegnate_al_tutor = (props) => {
    const [lista_classi_tutor, SET_lista_classi_tutor] = useState([]);

    useEffect(() => {
        Carica_classi_x_account()
    }, []);


    const Carica_classi_x_account = () => {
        //    funzione_set_aggiornamento(true)
        console.log('Carica_domande_x_account')
        console.log(props.tutor._id)
        
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}

        axios.get('/classi/classi5/' + utente + '/' + props.tutor._id)
            .then((res) => {
                console.log('CLASSI X TUTOR appena fecciate da mongo')
                console.log(res.data)
                SET_lista_classi_tutor(res.data)
            }).catch((error) => {
                console.log(error)
            });
    }


    return (
        <div>
		 <ListGroup>
            {lista_classi_tutor.map(function (item_classe, index2) {
                {
                    //                        console.log(item)
                    return <>
                        
                            {item_classe.nome}
                        
                        <hr class="rounded"></hr>
                    </>
                }
            })
            }
        </ListGroup>
        </div>
    )
}
export default Trova_classi_assegnate_al_tutor